const Translations = [
	{
		language: 'en',
		fonts: ['Roboto', "Oswald",'sans-serif'],
		mainMenu: {
			home: 'Home Page',
			library: 'Learning Library',
			offline: 'Offline Courses',
			feed: 'News Feed',
			notification: 'Notifications',
			helpdesk: 'Help Desk',
			logout: 'Logout',
			login: 'Login',
			sync: 'Sync',
			workshop: 'Workshop',
		},
		selectedLanguage: 'Select Language',
		openBtn: 'Click to Open',
		startBtn: 'Play',
		overlay: {
			correct: 'Correct!',
			incorrect: 'Incorrect!',
			thanks: 'Thank You!',
			close: 'Continue',
			deckFinished: 'You finished the deck on ',
			testPassed: 'You passed the test:',
			testFailed: 'You failed the test:',
			deckEnd: 'Submit and Continue',
			returnDeck: 'Or return to the deck',
			returnTest: 'Or take the test again',
			completion: 'All Complete!',
			passed: 'Well Done! You Passed!',
			failed: 'Ouch! You Failed!',
			next: 'Next',
			knowmore: 'Know More',
			resume: 'Resume',
			cancel: 'Cancel',
			syncScore: 'Syncing your data, please wait..',
		},
		templateActions: {
			checkAnswer: 'Check Answer',
			submitAnswer: 'Submit Answer',
			thanks: 'Thanks for your response',
			go: 'Go',
		},
		loginPage: {
			email: {
				placeholder: 'Enter Email',
				text: 'Email',
			},
			password: {
				placeholder: 'Enter Password',
				text: 'Password',
			},
			login: 'Login',
			forgotPassword: 'Forgot Password?',
		},
		forgotPasswordPage: {
			email: {
				placeholder: 'Enter Email',
				text: 'Email',
			},
			login: 'Login?',
			send_email: 'Send Mail',
		},
		programPage: {
			noContent: 'There is no content available for you under this header',
		},
		feedPage: {
			noPost: 'No post available for you under this header',
		},
	},
	{
		language: 'hi',
		fonts: ['Roboto', "Oswald",'sans-serif'],
		mainMenu: {
			home: 'मुख्य मेनू',
			library: 'ज्ञान संग्रह',
			offline: 'ऑफ़लाइन पढ़ें',
			feed: 'बातचीत',
			notification: 'सूचनाएं',
			logout: 'लोग आउट',
		},
		selectedLanguage: 'चयनित भाषा',
		openBtn: 'कोर्स खोलें',
		startBtn: 'आगे बढ़ें',
		overlay: {
			correct: 'सही उत्तर!',
			incorrect: 'गलत जवाब!',
			thanks: 'धन्यवाद!',
			close: 'बंद करे',
			next: 'आगे बढ़ें',
			knowmore: 'अधिक जानिए',
			resume: 'आगे बढ़ें',
			cancel: 'बंद करे',
			syncScore: 'कृपया प्रतीक्षा करें',
			deckend: 'सबमिट करें और जारी रखें',
			score: 'स्कोर',
			completion: 'समापन',
			passed: 'उत्तीर्ण',
			failed: 'अनुत्तीर्ण',
		},
		templateActions: {
			checkAnswer: 'अपना उत्तर जाँच लें',
			submitAnswer: 'अपना जवाब सबमिट करें',
			thanks: 'आपके उत्तर के लिए धन्यवाद',
			go: 'आगे बढ़ें',
		},
		loginPage: {
			email: {
				placeholder: 'ईमेल दर्ज करें',
				text: 'ईमेल',
			},
			password: {
				placeholder: 'पासवर्ड दर्ज करें',
				text: 'पासवर्ड',
			},
			login: 'लॉग इन',
			forgotPassword: 'पासवर्ड भूल गए',
		},
		forgotPasswordPage: {
			email: {
				placeholder: 'ईमेल दर्ज करें',
				text: 'ईमेल',
			},
			login: 'लॉग इन?',
			send_email: 'मेल भेजे',
		},
		programPage: {
			noContent: 'इस शीर्ष लेख के अंतर्गत आपके लिए कोई भी सामग्री उपलब्ध नहीं है',
		},
	},
];

export { Translations };
